import React, { useEffect, useState } from "react";
import CustomModal from '../../components/common/CustomModal';
import { MdOutlineClose } from "react-icons/md";
import axiosAuthInstance from "../../utils/axios/axiosAuthInstance";
import { getRole } from "../../utils/cookies/cookies";

const permissionsData = [
    { key: "company_controllers", label: "Company Controllers" },
    { key: "master_controllers", label: "Master Controllers" },
    { key: "task_controllers", label: "Task Controllers" },
    { key: "marketing", label: "Marketing" },
    { key: "accounting", label: "Accounting" },
    { key: "team", label: "Team" },
    { key: "task", label: "Task" },
    { key: "company", label: "Company" },
    { key: "document", label: "Document" },
    { key: "company_branding", label: "Company Branding" },
    { key: "view_360", label: "360 View" },
    { key: "ar", label: "AR View" },
];

const PermissionForm = ({ isOpen, handleClose, user }) => {
    const role = getRole()

    const [permissions, setPermissions] = useState(
        permissionsData.reduce((acc, curr) => {
            acc[curr.key] = { view: false, add: false, edit: false, delete: false };
            return acc;
        }, {})
    );

    const handleCheckboxChange = (moduleKey, permissionType) => {
        setPermissions((prev) => ({
            ...prev,
            [moduleKey]: {
                ...prev[moduleKey],
                [permissionType]: !prev[moduleKey][permissionType],
            },
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const formattedPermissions = Object.keys(permissions).reduce((acc, moduleKey) => {
                const selectedPermissions = [];
                if (permissions[moduleKey].view) selectedPermissions.push("View");
                if (permissions[moduleKey].add) selectedPermissions.push("Add");
                if (permissions[moduleKey].edit) selectedPermissions.push("Edit");
                if (permissions[moduleKey].delete) selectedPermissions.push("Delete");

                if (selectedPermissions.length > 0) {
                    acc[moduleKey] = selectedPermissions;
                }
                return acc;
            }, {});

            const payload = {
                team_id: user._id,
                permissions: formattedPermissions
            };

            const response = await axiosAuthInstance.put(`team/permission-assign`, payload);

            if (response.status === 200) {
                handleClose()
            }
        } catch (error) {
            console.log("error", error)
        }
    };

    const getUserPermission = async () => {
        try {
            const response = await axiosAuthInstance.get(`team/permission/${user._id}`);
            const fetchedPermissions = response.data?.result;

            // Update the state with the fetched permissions
            const updatedPermissions = permissionsData.reduce((acc, curr) => {
                acc[curr.key] = {
                    view: fetchedPermissions[curr.key]?.includes("View") || false,
                    add: fetchedPermissions[curr.key]?.includes("Add") || false,
                    edit: fetchedPermissions[curr.key]?.includes("Edit") || false,
                    delete: fetchedPermissions[curr.key]?.includes("Delete") || false,
                };
                return acc;
            }, {});

            setPermissions(updatedPermissions);
        } catch (error) {
            console.error('Failed to fetch permissions:', error);
        }
    };


    useEffect(() => {
        if (role === 'admin') {
            getUserPermission()
        }
    }, [])

    return (
        <CustomModal handleCloseModal={handleClose} closeModal={!isOpen} isFullwidth={true}>
            <div className="p-6">
                <button
                    onClick={handleClose}
                    className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
                >
                    <MdOutlineClose size={24} />
                </button>
                <form onSubmit={handleSubmit}>
                    <h2 className="text-2xl font-semibold text-gray-700 mb-6 text-center">Add Permission to {user.full_name}</h2>
                    <div className="space-y-4">
                        {permissionsData.map(({ key, label }) => (
                            <div key={key} className="flex justify-between items-center">
                                <span className="text-gray-700">{label}</span>
                                <div className="space-x-4">
                                    <label className="inline-flex items-center">
                                        <input
                                            type="checkbox"
                                            checked={permissions[key].view}
                                            onChange={() => handleCheckboxChange(key, "view")}
                                            className="form-checkbox h-5 w-5 text-purple-600"
                                        />
                                        <span className="ml-2 text-gray-600">View</span>
                                    </label>
                                    <label className="inline-flex items-center">
                                        <input
                                            type="checkbox"
                                            checked={permissions[key].add}
                                            onChange={() => handleCheckboxChange(key, "add")}
                                            className="form-checkbox h-5 w-5 text-purple-600"
                                        />
                                        <span className="ml-2 text-gray-600">Add</span>
                                    </label>
                                    <label className="inline-flex items-center">
                                        <input
                                            type="checkbox"
                                            checked={permissions[key].edit}
                                            onChange={() => handleCheckboxChange(key, "edit")}
                                            className="form-checkbox h-5 w-5 text-purple-600"
                                        />
                                        <span className="ml-2 text-gray-600">Edit</span>
                                    </label>
                                    <label className="inline-flex items-center">
                                        <input
                                            type="checkbox"
                                            checked={permissions[key].delete}
                                            onChange={() => handleCheckboxChange(key, "delete")}
                                            className="form-checkbox h-5 w-5 text-purple-600"
                                        />
                                        <span className="ml-2 text-gray-600">Delete</span>
                                    </label>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="mt-8 flex justify-center space-x-4">
                        <button
                            type="submit"
                            className="bg-orange-500 text-white px-4 py-2 rounded hover:bg-orange-600 transition duration-200"
                        >
                            Submit
                        </button>
                        <button
                            type="button"
                            className="bg-gray-300 text-gray-700 px-4 py-2 rounded hover:bg-gray-400 transition duration-200"
                        >
                            Cancel
                        </button>
                    </div>
                </form>
            </div>
        </CustomModal>
    );
};

export default PermissionForm;
